import { ref } from 'vue';

/**
 * Whether the sign-out confirmation is on screen.
 *
 * A module-scope flag rather than a prop: Sign out is raised from screens that
 * share no parent worth threading a prop through (the home screen's bar and
 * `VerifyEmailGate`, today), and one boolean read by one dialog mounted near
 * the root in `App.vue` means a new caller inherits the dialog by calling one
 * function.
 *
 * The dialog performs the logout, not this module: signing out has exactly one
 * consequence — `session.logout()` — and a store that imported the session to
 * call it would make a two-line flag depend on the whole auth module.
 */
const asked = ref(false);

/** Read by `ui/ConfirmSignOut.vue`. */
export const signOutAsked = asked;

/** Opens the confirmation. Every Sign out control calls this instead of logging out. */
export function askSignOut(): void {
  asked.value = true;
}

/**
 * Closes it without signing out.
 *
 * Called by Cancel, by the backdrop and by Escape — the safe answer has to be
 * the easy one, which is the rule the purchase dialog states.
 */
export function cancelSignOut(): void {
  asked.value = false;
}
